import React from 'react';
import { TableCell } from '@mui/material';
import CalculatedValueDisplay from '../CalculatedValueDisplay';

type CalculatedValueTableCellProps = {
  details: any;
  isChildRow?: boolean;
  formatFunction?: (value: number) => string;
  borderRightColor?: string;
};

const CalculatedValueTableCell: React.FC<CalculatedValueTableCellProps> = ({
  details,
  isChildRow = false,
  formatFunction,
  borderRightColor,
}) => {
  const borderStyle = { borderRight: `1px solid ${borderRightColor ?? '#A3AED03D'}` };
  const sx = isChildRow ? { opacity: 0.6, textAlign: 'right', ...borderStyle } : { textAlign: 'right', ...borderStyle };

  if (details && typeof details === 'object' && 'isNA' in details) {
    return (
      <TableCell sx={sx}>
        <CalculatedValueDisplay isNA={details.isNA} style={isChildRow ? { opacity: 0.6 } : undefined} />
      </TableCell>
    );
  }

  return (
    <TableCell sx={sx}>
      <CalculatedValueDisplay
        calculations={details?.calculations}
        formatFunction={formatFunction}
        style={isChildRow ? { opacity: 0.6 } : undefined}
      />
    </TableCell>
  );
};

export default CalculatedValueTableCell;
